import { DefaultButton, Label, PrimaryButton, Overlay, Stack, StackItem, IconButton, Text, FocusTrapZone, TextField, TooltipHost } from "@fluentui/react"; 
import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCount } from "../ChatBot.selectors";
import { userInfoSelector } from "@ec-oem/ec.oem.oa3.ui.core/components";
import { addMessageItem, getCosmicResponse, setConversationAllowed } from "../ChatBot.actions";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react";
import "./Support.scss"

const dialogContentProps = {
	type: DialogType.normal,
	title: "Create Support Ticket",
	closeButtonAriaLabel: "Close",
	subText: "Proceed to create a support ticket with OEM Support Team?"
};

const ALLOWED_FILE_TYPES = ".txt,.pdf,.doc,.docx,.csv,.xls,.xlsx,.zip,.jpeg,.jpg,.png";
const MAX_FILE_SIZE_MB = 10; 
const MAX_FILES = 5; 
const MAX_FILENAME_LENGTH = 100; 
const FILE_TYPE_REGEX = /\.(txt|pdf|doc|docx|csv|xls|xlsx|zip|jpeg|jpg|png)$/i;

class Support extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showmodal: false,
			attachments: [], 
			attachmentError: "", 
			notes: "" 
		};
		this.openDialog = this.openDialog.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.fileInputRef = React.createRef(); 
	}

	openDialog = () => {
		this.setState({ showmodal: true });
	};

	closeDialog = () => {
		this.setState({ showmodal: false, attachments: [], attachmentError: "", notes: "" }); 
	};

	handleFileChange = (event) => { 
		const files = Array.from(event.target.files); 
		const currentCount = this.state.attachments.length; 
		if (currentCount + files.length > MAX_FILES) { 
			this.setState({ attachmentError: `Maximum ${MAX_FILES} files allowed.` }); 
			if (this.fileInputRef.current) this.fileInputRef.current.value = ""; 
			return; 
		} 
		const invalidTypeFiles = files.filter(f => !FILE_TYPE_REGEX.exec(f.name)); 
		if (invalidTypeFiles.length > 0) { 
			const allowedList = ALLOWED_FILE_TYPES.split(",").map(t => t.trim()).join(", "); 
			this.setState({ attachmentError: `Unsupported file type. Please upload one of: ${allowedList}.` }); 
			if (this.fileInputRef.current) this.fileInputRef.current.value = ""; 
			return; 
		} 
		const longNameFiles = files.filter(f => f.name.length > MAX_FILENAME_LENGTH); 
		if (longNameFiles.length > 0) { 
			this.setState({ attachmentError: `File name must be under ${MAX_FILENAME_LENGTH} characters.` }); 
			if (this.fileInputRef.current) this.fileInputRef.current.value = ""; 
			return; 
		} 
		const oversizedFiles = files.filter(f => f.size > MAX_FILE_SIZE_MB * 1024 * 1024); 
		if (oversizedFiles.length > 0) { 
			this.setState({ attachmentError: `Each file must be under ${MAX_FILE_SIZE_MB}MB.` }); 
			if (this.fileInputRef.current) this.fileInputRef.current.value = ""; 
			return; 
		} 
		this.setState(prevState => ({ 
			attachments: [...prevState.attachments, ...files], 
			attachmentError: "" 
		})); 
		if (this.fileInputRef.current) { 
			this.fileInputRef.current.value = ""; 
		} 
	}; 

	removeAttachment = (index) => { 
		this.setState(prevState => ({ 
			attachments: prevState.attachments.filter((_, i) => i !== index) 
		})); 
	}; 

	onSubmit = () => {
		const { attachments, notes } = this.state; 
		this.props.actions.addMessageItem(null);
		this.props.actions.setConversationAllowed(false);
		this.setState({ showmodal: false, attachments: [], attachmentError: "", notes: "" }); 
		this.props.actions.getCosmicResponse(attachments, notes); 
	};

	render() {
		return (
			<div>
				{/* <Label className="label-text">
                {"The Chat interface is in Beta phase and is continuously learning and improving the scope of tickets it can resolve."}
                </Label> */}
				<DefaultButton onClick={this.openDialog} className="cosmic-button" text="Create Support Ticket" />
				{this.state.showmodal && <Overlay
					isBlocking={true}
					className ={"support-overlay-modal"}
				>
				<FocusTrapZone onKeyDown={(e) => { if (e.key === 'Escape') this.closeDialog(); }}>
					<div className="support-overlay-content" role="dialog" aria-modal="true" aria-labelledby="supportOverlayCreateSupport">
						<Stack horizontal className="suuppor-header-stack padd-bottom10">
						<h2 id="supportOverlayCreateSupport" className="support-ticket-title">
							{this.props.intl.formatMessage({
								id: "supportOverlay.createsupportticket",
								defaultMessage: "Create Support Ticket"
							})}
						</h2>
								<StackItem>
									<IconButton
										iconProps={{ iconName: "Cancel" }}
										ariaLabel="Close Create Support Ticket popup"
										onClick={(event, value) => {
											this.setState({ showmodal: false });
										}}
									/>
								</StackItem>
							</Stack>
							<Stack className="padd-bottom10"><Text>{this.props.intl.formatMessage({ id: "supportOverlay.message", defaultMessage: "Proceed to create a support ticket with OEM Support Team?" })}</Text></Stack>						
							<Stack className="padd-bottom10 notes-section">
								<Label>{this.props.intl.formatMessage({ id: "supportOverlay.notes", defaultMessage: "Additional Notes (optional)" })}</Label>
								<TextField 
									multiline 
									resizable={false} 
									value={this.state.notes} 
									onChange={(_, val) => this.setState({ notes: val || "" })} 
									placeholder={this.props.intl.formatMessage({ id: "supportOverlay.notesPlaceholder", defaultMessage: "Please be aware that the chat transcript will be shared with the support agent. If you have any additional information to provide, please include it here." })} 
									maxLength={500} 
									styles={{ 
										field: { 
											height: 96, 
											overflowY: "auto", 
											overflowX: "hidden", 
											wordBreak: "break-word", 
											resize: "none" 
										} 
									}} 
								/> 
								<Text variant="small" className="notes-char-counter" aria-live="polite" aria-atomic="true">{this.state.notes.length} / 500</Text> 
							</Stack> 							
							<Stack className="padd-bottom10 attachment-section"> 
								<Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}> 
									<Label htmlFor="support-file-input">{this.props.intl.formatMessage({ id: "supportOverlay.attachments", defaultMessage: "Attachments (optional)" })}</Label>
								<TooltipHost 
									content={ 
										<ul style={{ margin: "4px 0", paddingLeft: 16, listStyle: "disc" }}> 
											<li>{`Maximum ${MAX_FILES} files per submission.`}</li> 
											<li>{`Each file must be under ${MAX_FILE_SIZE_MB}MB.`}</li> 
											<li>{`File name must be under ${MAX_FILENAME_LENGTH} characters.`}</li> 
											<li>{`Allowed types: ${ALLOWED_FILE_TYPES.split(",").map(t => t.trim()).join(", ")}`}</li> 
										</ul> 
									} 
									closeDelay={200} 
								> 
									<IconButton 
										className="attachment-info-button" 
										iconProps={{ iconName: "Info" }} 
										ariaLabel="Attachment rules" 
										styles={{ root: { width: 16, height: 16, color: "#0078d4" }, icon: { fontSize: 14 } }} 
									/> 
								</TooltipHost> 
							</Stack> 
								<input 
									type="file" 
									id="support-file-input"
									multiple 
									accept={ALLOWED_FILE_TYPES} 
									ref={this.fileInputRef} 
									onChange={this.handleFileChange} 
									style={{ display: "none" }} 
								/> 
							<DefaultButton className="add-files-button" 									
									iconProps={{ iconName: "Attach" }} 
									text={this.props.intl.formatMessage({ id: "supportOverlay.addFiles", defaultMessage: "Add Files" })} 
									onClick={() => this.fileInputRef.current && this.fileInputRef.current.click()} 
									disabled={this.state.attachments.length >= MAX_FILES} 
								/> 
								{this.state.attachmentError && ( 
									<Text className="attachment-error">{this.state.attachmentError}</Text> 
								)} 
								{this.state.attachments.length > 0 && ( 
									<Stack className="attachment-list" tokens={{ childrenGap: 4 }}> 
										{this.state.attachments.map((file, index) => ( 
											<Stack horizontal verticalAlign="center" key={index} tokens={{ childrenGap: 8 }}> 
											<IconButton className="attachment-item-button"
												iconProps={{ iconName: "Cancel" }} 
												title="Remove" 
												ariaLabel={`Remove ${file.name}`} 
												onClick={() => this.removeAttachment(index)} 
												/> 
												<Text variant="small">{file.name} ({(file.size / 1024).toFixed(1)} KB)</Text> 
											</Stack> 
										))} 
									</Stack> 
								)} 
							</Stack> 
							<Stack horizontal className="support-overlay-buttons-stack">
								<StackItem className="button-stack-item submit">
									<PrimaryButton
										primary
										allowDisabledFocus
										onClick={this.onSubmit}
										ariaLabel={this.props.intl.formatMessage({ id: "supportOverlay.Submit", defaultMessage: "Create Ticket" })}>
										{this.props.intl.formatMessage({ id: "supportOverlay.Submit", defaultMessage: "Create Ticket" })}
									</PrimaryButton>
								</StackItem>
								<StackItem className="button-stack-item cancel">
									<DefaultButton
										allowDisabledFocus
										onClick={this.closeDialog}
										ariaLabel={this.props.intl.formatMessage({ id: "supportOverlay.Cancel", defaultMessage: "Cancel" })}>
										{this.props.intl.formatMessage({ id: "supportOverlay.Cancel", defaultMessage: "Cancel" })}
									</DefaultButton>
								</StackItem>
							</Stack>
						</div>
					</FocusTrapZone>
					
				{/* <Dialog
					hidden={!this.state.showmodal}
					onDismiss={this.closeDialog}
					dialogContentProps={dialogContentProps}
					modalProps={{
						isBlocking: false,
						styles: { main: { maxWidth: 450 } }
					}}
					// modalProps={modalProps}
				>
					<DialogFooter>
						<PrimaryButton onClick={this.onSubmit} text="Create Ticket" />
						<DefaultButton onClick={this.closeDialog} text="Cancel" />
					</DialogFooter>
				</Dialog> */}
				</Overlay>}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		count: getCount(state),
		userinfo: userInfoSelector(state)
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators({ getCosmicResponse, addMessageItem, setConversationAllowed }, dispatch)
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Support));
